module.exports = __webpack_public_path__ + "img/dark-logo.7fe7639d.png";